export enum Resource {
  PURCHASE_BY_SCHNEIDER
}
